class SlidingAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    // Config
    this.sliderArrows = this.dataset.sliderArrows == 'true';
    this.sliderDuration = parseInt(this.dataset.sliderDuration);
    this.sliderAutoplay = this.dataset.sliderAutoplay == 'true';
    // Internal
    this.slidesWrapper = this.querySelector('.sliding-announcement-bar');
    this.slides = this.slidesWrapper.children;
    this.carousel = null;
    this.initCarousel();
  }
  initCarousel() {
    if(this.slides.length > 1) {
      this.carousel = new KeenSlider(this.slidesWrapper, {
        mode: "snap",
        loop: true,
        dots: false,
        prevButton: this.sliderArrows ? this.slidesWrapper.parentNode.querySelector('.ab-arrow.prev') : '',
        nextButton: this.sliderArrows ? this.slidesWrapper.parentNode.querySelector('.ab-arrow.next') : '',
        autoplay: this.sliderAutoplay,
        duration: this.sliderDuration,
        rtl: true
      });
    } else {
      this.slidesWrapper.classList.add('initialized');
    }
  }
}
customElements.define('sliding-announcement-bar', SlidingAnnouncementBar);